import { tv } from "../../../variants/tv.js";
const heroCarouselVariants = tv({
    slots: {
        wrapperParentSlot: '@container w-full',
        prevButtonSlot: 'top-[calc(50%-20px)] @min-[1340px]:top-[calc(50%-20px)] @min-[1340px]:bottom-auto @min-[1340px]:left-[8px] @min-[1340px]:translate-x-0',
        nextButtonSlot: 'top-[calc(50%-20px)] @min-[1340px]:top-[calc(50%-20px)] @min-[1340px]:right-[8px] @min-[1340px]:bottom-auto @min-[1340px]:left-auto @min-[1340px]:translate-x-0',
        hiddenButtonSlot: 'top-[calc(50%-20px)] @min-[1340px]:top-[calc(50%-20px)] @min-[1340px]:bottom-auto @min-[1340px]:left-[8px] @min-[1340px]:translate-x-0',
        bottomControlRowSlot: 'pointer-events-none absolute right-0 bottom-2 left-0 flex items-center justify-center gap-6 [&_button]:pointer-events-auto',
        dotsPaginationSlot: 'bottom-0 @3xl:bottom-2'
    },
    variants: {
        isTouchDevice: {
            true: {},
            false: {
                prevButtonSlot: 'hidden @3xl:block',
                nextButtonSlot: 'hidden @3xl:block',
                hiddenButtonSlot: 'hidden @3xl:block'
            }
        }
    },
    defaultVariants: {
        isTouchDevice: false
    }
});
export { heroCarouselVariants };
